import styled, { css } from 'styled-components';

export const ModalPixRecAlertTitle = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    text-align: center;
    margin: 0px 0px 32px 0px;

    @media (max-width: ${theme.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.sm2};
    }
  `}
`;

export const ModalPixRecAlertDescription = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.description};
    text-align: center;
    margin: 0 0 32px 0;
  `}
`;

export const ModalPixRecAlertButtonContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
`;
